// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_vf-8";
export var editMode = "_vf-3";
export var headerRow = "_vf-a";
export var headerTitle = "_vf-b";
export var product = "_vf-1";
export var productDetails = "_vf-5";
export var productDivider = "_vf-7";
export var productImage = "_vf-2";
export var productInfo = "_vf-4";
export var productTitle = "_vf-6";
export var strikethrough = "_vf-9";
export var upsellProductsCard = "_vf-0";